import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=379587b4&scoped=true&"
import script from "./AddUser.vue?vue&type=script&lang=js&"
export * from "./AddUser.vue?vue&type=script&lang=js&"
import style0 from "./AddUser.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddUser.vue?vue&type=style&index=1&id=379587b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379587b4",
  null
  
)

export default component.exports